import { Box } from "@mui/material";

export default function News() {
  return (
    <Box className="App-body">
      <h1>Important updates coming soon!</h1>
    </Box>
  );
}
